export default __webpack_public_path__ + "static/kristoffer-06e934614029e8decc54cadb58e2d510.png";